/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DirectionRefStructure } from './DirectionRefStructure';
import type { GeneralAttributeStructure } from './GeneralAttributeStructure';
import type { InternationalTextStructure } from './InternationalTextStructure';
import type { JourneyRefStructure } from './JourneyRefStructure';
import type { LineRefStructure } from './LineRefStructure';
import type { ModeStructure } from './ModeStructure';
import type { OperatingDayRefStructure } from './OperatingDayRefStructure';
import type { OperatorRefStructure } from './OperatorRefStructure';
import type { ServiceViaPointStructure } from './ServiceViaPointStructure';
import type { SharingServiceStructure } from './SharingServiceStructure';
import type { SituationFullRefStructure } from './SituationFullRefStructure';
import type { StopPointRefStructure } from './StopPointRefStructure';
import type { VehicleRefStructure } from './VehicleRefStructure';

export type ContinuousServiceStructure = {
  continuousMode?: ContinuousServiceStructure.continuousMode;
  individualMode?: ContinuousServiceStructure.individualMode;
  operatingDayRef?: OperatingDayRefStructure;
  vehicleRef?: VehicleRefStructure;
  journeyRef?: JourneyRefStructure;
  lineRef?: LineRefStructure;
  directionRef?: DirectionRefStructure;
  mode?: ModeStructure;
  publishedLineName?: InternationalTextStructure;
  operatorRef?: OperatorRefStructure;
  routeDescription?: InternationalTextStructure;
  via?: Array<ServiceViaPointStructure>;
  attribute?: Array<GeneralAttributeStructure>;
  sharingService?: SharingServiceStructure;
  originStopPointRef?: StopPointRefStructure;
  originText?: InternationalTextStructure;
  destinationStopPointRef?: StopPointRefStructure;
  destinationText?: InternationalTextStructure;
  situationFullRef?: Array<SituationFullRefStructure>;
};

export namespace ContinuousServiceStructure {
  export enum continuousMode {
    WALK = 'WALK',
    DEMAND_RESPONSIVE = 'DEMAND_RESPONSIVE',
    REPLACEMENT_SERVICE = 'REPLACEMENT_SERVICE',
  }

  export enum individualMode {
    WALK = 'WALK',
    CYCLE = 'CYCLE',
    TAXI = 'TAXI',
    SELF_DRIVE_CAR = 'SELF_DRIVE_CAR',
    OTHERS_DRIVE_CAR = 'OTHERS_DRIVE_CAR',
    MOTORCYCLE = 'MOTORCYCLE',
    TRUCK = 'TRUCK',
  }
}
